
import { ParamsService } from '../../services/params.service';
import { constantes } from '../../constantes';
import { environment } from '../../../environments/environment';
import { InfoService } from '../../interfaces/infoservice.interface';
import { Service } from '../../interfaces/service.interface';
import { Company } from '../../interfaces/company.interface';
import { ApplicationRef, Component, EventEmitter, Input, OnInit, Output, SimpleChange, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {
	
	@Output() onClose:EventEmitter<void> = new EventEmitter();
	@Output() onUpdate:EventEmitter<void> = new EventEmitter();
	
	@Input() data:Company & Service & InfoService & any;
	@Input() type:string;
	
	
	headerColor:string;
	iconHeader:string = '';
	titleContact:string;
	colorTitle:string;
	titleItalic:string;
	urlContact:string;

  constructor(
		private paramsService:ParamsService,
		private app: ApplicationRef,
	) { }

  ngOnInit() {
		
		
		
	}
	
	
	
	
	ngOnChanges(changes:SimpleChanges){
		
		if(changes.type && this.type){
			
			
			if(this.type == 'infos') this.iconHeader = 'infoservice';
			else if(this.type == 'company') this.iconHeader = 'company';
			else if(this.type == 'address') this.iconHeader = 'address';
			else if(this.type == 'service'){
				//todo
				
				this.iconHeader = 'service-' + this.getServiceKey(this.data.type);
			}
			else this.iconHeader = this.type;
			
			// debugger;
			
			if(this.type == 'infos') this.titleContact = "Pour plus d'informations";
			else if(this.type == 'company') this.titleContact = "Informations";
			else this.titleContact = "Coordonnées";
			
			this.titleItalic = this.data.domain || this.data.type;
			if(this.type == 'infos'){
				if(this.data.dateEnd) this.titleItalic = 'Du '+this.ts2date(this.data.dateStart) +' au '+this.ts2date(this.data.dateEnd);
				else this.titleItalic = 'À partir du '+this.ts2date(this.data.dateStart);
				
			}
			else if(this.type == 'address') this.titleItalic = '';
			
			if(this.type == 'infos') this.headerColor = '#FF5100';
			else if(this.type == 'company') this.headerColor = '#4F80C1';
			else if(this.type == 'service') this.headerColor = '#D9861C';
			else if(this.type == 'address') this.headerColor = '#D3D726';
			
			if(this.type == 'service') this.colorTitle = '#D9861C';
			else this.colorTitle = '#4F80C1';
			/* 
			if(this.type == 'infos'){
				this.data.email = 'todo@email.com';
			}
			*/
			
			let baseurl:string = environment.backBaseUrl;
			let url:string = '';
			if(environment.mockApi) url = 'assets/mock/imguploads/' + this.data.logo;
			else url = baseurl + '/imguploads/' + this.data.logo;
			
			if(this.data.logo) this.data.logoUrl = url;
			else this.data.logoUrl = null;
			
			// debugger;
		}
		
		if(this.data && this.data.email) this.urlContact = 'mailto:'+this.data.email;
		else this.urlContact = '/contact';
		
		if(changes.data && this.data){
			this.onUpdate.emit();
		}
	}
	
	
	
	private ts2date(ts:number):string
	{
		let date:Date = new Date(ts * 1000);
		let datevalues:string[] = [
			 this.format2number(date.getDate()),
			 this.format2number(date.getMonth()+1),
			 this.format2number(date.getFullYear()),
		];
		return datevalues.join('/');
	}
	
	private format2number(value:number):string
	{
		return value < 10 ? '0' + value : value + '';
	}
	
	
	 
	private getServiceKey(dbvalue:string):string
	{
		for(let k in constantes.serviceTypes){;
			let item = constantes.serviceTypes[k];
			if(item.dbvalue == dbvalue) return item.id;
		}
		return null;
	}
	
	
	clickRoute():void
	{
		this.paramsService.dispatch('route', this.data);
		this.paramsService.dispatch('closeModal', null);
		
		setTimeout(function() {
			this.app.tick();
		}.bind(this), 100);
	}
	
	
	close():void
	{
		this.onClose.emit();
	}

}
